import * as jsxRuntime from "/home/jenkins/agent/workspace/epb-only-nodejs-f01eab0f-4771-472a-bb6b-f65f3f1f0123/node_modules/react/jsx-runtime.js"
export const jsx = jsxRuntime.jsx
export const jsxs = jsxRuntime.jsxs
export const Fragment = jsxRuntime.Fragment